import {html} from 'lit';
import type {Match} from '../IMatchData';

const content = (matches: Match[]) => {
  return html`
    ${matches.map(match => html`
      <li class="game${match.index} list-entry">
        <a href="${match.url}" class="matchlink">
          <div class="team1">
            <img src="${match['hometeam-logo']}" class="teamlogo" srcset="${match['hometeam-logo2x']} 2x"
                 alt="${match['hometeam-name']}" title="${match['hometeam-name']}"/>
            <span class="js-teamname teamname" data-text-s="${match['hometeam-microname']}"
                  data-text-m="${match['hometeam-shortname']}"
                  data-text-l="${match['hometeam-name']}">${match['hometeam-shortname']}</span>
          </div>
          <div class="vs">
            <div class="${getGameTimeClass(match.status)} js-game-time">${match.time}</div>
            <div class="${getGameScoreClass(match.status)}score js-game-score">${match.score}</div>
          </div>
          <div class="team2">
            <img src="${match['guestteam-logo']}" class="teamlogo" srcset="${match['guestteam-logo2x']} 2x"
                 alt="${match['guestteam-name']}" title="${match['guestteam-name']}"/>
            <span class="js-teamname teamname" data-text-s="${match['guestteam-microname']}"
                  data-text-m="${match['guestteam-shortname']}"
                  data-text-l="${match['guestteam-name']}">${match['guestteam-shortname']}</span>
          </div>
        </a>
      </li>`
    )}
  `;
};

function getGameTimeClass(status: string) {
  return status === 'live' ? 'live' : 'date';
}

function getGameScoreClass(status: string) {
  return status === 'pending' ? 'no' : '';
}

export {content};
